module.exports = __webpack_public_path__ + "static/media/mail.81a0f709.png";